import PasswordInquiryContainer from 'containers/auth/PasswordInquiryContainer';
import React from 'react';

export default function PasswordInquiry() {
  return <PasswordInquiryContainer jestSubmit={() => {}} />;
}
